import api from 'services/api';

export async function getJobs(organizationId: string) {
  return api.get(`api/dashboard/organizations/${organizationId}/jobs`);
}
